<template>
  <div class="expande-horizontal wrap pa-3 pl-1 pb-0 pt-0 pr-0 fonte">
    <v-flex class="pa-1"  xs12>
      <v-text-field
        dense
        filled
        append-icon="mdi-magnify"
        label="Faça uma busca..."
        placeholder="ex: Patrick"
        v-model="filter.search"
        hide-details
        :color="$theme.primary"
        @input="updateList"
      ></v-text-field>
    </v-flex>
    <v-flex  class="pa-1" xs6>
      <v-text-field
        v-model="filter.atipicity"
        dense
        filled
        append-icon="mdi-magnify"
        label="Atipicidade"
        placeholder=""
        hide-details
        :color="$theme.primary"
        @input="updateList"
      ></v-text-field>
    </v-flex>
    <v-flex class="pa-1"  xs6>
      <v-select
        v-model="filter.gender"
        dense
        filled
        :items="['Masculino', 'Feminino']"
        append-icon="mdi-magnify"
        label="Gênero"
        placeholder=""
        hide-details
        :color="$theme.primary"
        @input="updateList"
      ></v-select>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: ["filter"],
  methods: {
    updateList() {
      this.$forceUpdate();
    }
  }
};
</script>
